module.exports = "../images/icons/modify-profile.svg";